import { objectSchema, optionalTolerant } from '../../_utils/fcdc-v2'
import * as z from 'zod'

export const i18nStringSchema = objectSchema({
  language: optionalTolerant(z.string()),
  value: optionalTolerant(z.string()),
})
